// extracted by mini-css-extract-plugin
module.exports = {"feedbackAndShares":"_36tSgXRwAEI9jdHLYyJvU0","creditsRow":"_1jVfq-G78lQ49CKsV4KA_f"};